import React from 'react';
import { createPortal } from 'react-dom';
import { Spinner } from 'components/spinner/Spinner';
import { CardPaymentHookStage } from 'cardPayment/useCardPayment';

const titles: { [stage: string]: string } = {
  creating: 'Preparing your payment',
  confirming: 'Processing your payment',
  finalising: 'Confirming your payment',
};

type Props = { stage: CardPaymentHookStage };

/** Covers the whole page while paying, so nothing can be changed or navigated away from. */
export const CardPaymentProcessing: React.FC<Props> = ({ stage }) => {
  const title = titles[stage];

  if (!title) return null;

  // On the body, so a transformed parent such as a popout panel cannot confine it.
  return createPortal(
    <div className="CardPaymentProcessing" role="alertdialog" aria-busy="true" aria-live="assertive" aria-label={title}>
      <div className="CPPBox">
        <Spinner color={'#f59e16'} size={18} />
        <h3>{title}</h3>
        <p>Please don't close or refresh this page.</p>
      </div>
    </div>,
    document.body
  );
};
